import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

interface DialogButtonConfig {
  primaryButtonText?: React.ReactNode;
  secondaryButtonText?: React.ReactNode;
  secondaryEnable?: boolean;
  onOkAction?: () => void;
  onCancelAction?: () => void;
}

interface MUIConfirmDialogProps {
  show?: boolean;
  onClose?: () => void;
  title?: React.ReactNode;
  description?: React.ReactNode;
  dialogButtonConfig?: DialogButtonConfig;
}

function MUIConfirmDialog(props: MUIConfirmDialogProps) {
  const {
    show = false,
    onClose = () => {},
    title = "",
    description = "",
    dialogButtonConfig = {
      primaryButtonText: "Ok",
      secondaryButtonText: "Cancel",
      secondaryEnable: false,
      onOkAction: onClose,
      onCancelAction: onClose,
    },
  } = props;
  return (
    <Dialog
      open={show}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>{description}</DialogContent>
      <DialogActions>
        <Button
          onClick={dialogButtonConfig?.onOkAction}
          color="primary"
          autoFocus
        >
          {dialogButtonConfig?.primaryButtonText}
        </Button>

        {dialogButtonConfig?.secondaryEnable && (
          <Button onClick={dialogButtonConfig?.onCancelAction} autoFocus>
            {dialogButtonConfig?.secondaryButtonText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default MUIConfirmDialog;
